import React from 'react';
import { useHits } from 'react-instantsearch';

const ProductCards = (props) => {
    // eslint-disable-next-line no-unused-vars
    const { hits, sendEvent } = useHits(props);

    // if (window.filtersInit) {
    //     document.getElementById('listing').scrollIntoView({behavior:'instant'});
    // } else {
    //     setTimeout(function(){
    //         window.filtersInit = true;
    //     },1000)
    // }

    if (hits.length) {
        if (window.filtersInit) {
            document.getElementById('listing').scrollIntoView({behavior: 'instant'});
        } else {
            setTimeout(function() {
                window.filtersInit = true;
            }, 1000)
        }

        return (
            <div className="grid grid-cols-12 gap-5">
                {hits.map((hit) => (
                    <div key={hit.objectID} className="flex col-span-full sm:col-span-6 xl:col-span-4">
                        <div className="bg-white overflow-hidden h-full w-full border-2 border-grey-300 rounded flex flex-col justify-between">
                            <a href={props.baseUrl + hit.url} className="block relative overflow-hidden group">
                                <img srcSet={hit.image} alt={hit.alt} loading="lazy" width="300" height="300" className="w-full mt-4 transition ease-linear duration-300 group-hover:scale-105" />

                                { hit.data.brandImage &&
                                <div className="absolute top-0 right-0 pointer-events-none">
                                    <img className="h-12 w-auto" src={hit.data.brandImage} alt={hit.brand + ' logo'} loading="lazy" />
                                </div>
                                }
                            </a>
                            <div className="p-6 pt-3 flex-1">
                                <div>
                                    <a href={props.baseUrl + hit.url} className={props.clamping ? 'text-lg leading-snug font-bold decoration-transparent underline transition ease-linear duration-300 hover:decoration-black !line-clamp-2' : 'text-lg leading-snug font-bold decoration-transparent underline transition ease-linear duration-300 hover:decoration-black'}><h5>{hit.title}</h5></a>
                                </div>

                                <p className="mt-1 text-grey-500 text-[0.9375rem]">{hit.strapline}</p>
                                {props.excerpt &&
                                <p className={props.clamping ? 'leading-relaxed mt-2 text-sm text-black !line-clamp-3' : 'leading-relaxed mt-2 text-sm text-black'}>{hit.excerpt}</p>
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    } else {
        setTimeout(function() {
            document.getElementById('no-results')?.classList.remove('hidden');
        }, 500)

        return (
            <div id="no-results" className="border-2 border-grey-200 rounded p-6 sm:p-8 text-center max-w-screen-md mx-auto w-full hidden">
                <p className="font-bold text-green text-xl">{props.noresultsHeading}</p>
                <p className="text-sm md:text-base mt-2">{props.noresultsText}</p>
            </div>
        );
    }

}

export { ProductCards }
